import ApiFetcher from './helpers/api_fetcher';

window.ApiFetcher = ApiFetcher;
